import { Component, Input, OnInit } from '@angular/core';
import { ControlContainer, FormsModule, NgForm } from '@angular/forms';
import { Sentiments } from '../../../common/enums/sentiments.enum';
import { FormService } from '../../../common/services/form.service';
import { Field } from 'src/sb-tools/typescript/models/field.model';
import { ClientField } from '../../../common/models/client-field.model';
import { NgClass } from '@angular/common';
import { FormFieldLabelComponent } from '@form-field-module/common/components/form-field-label/form-field-label.component';

@Component({
    selector: 'sb-sentiment',
    templateUrl: './sentiment.component.html',
    styleUrls: ['./sentiment.component.scss'],
    viewProviders: [{ provide: ControlContainer, useExisting: NgForm }],
    imports: [NgClass, FormsModule, FormFieldLabelComponent],
})
export class SentimentComponent implements OnInit {
    @Input() formField: Field | ClientField;

    sentimentsEnum = Sentiments;

    constructor(
        public formService: FormService,
        private ngForm: NgForm,
    ) {}

    ngOnInit() {
        if (!this.formField.value || !this.isValueCorrect()) {
            this.formField.value = this.sentimentsEnum.question;
        } else {
            this.setPreselectedValue();
        }

        setTimeout(() => {
            this.activate(this.formField.value);
        });
    }

    activate(value) {
        this.formField.value = value;
        this.formService.activeSentimentValue = this.sentimentsEnum[value];
        // trigger form values changes
        this.ngForm.form.updateValueAndValidity({ onlySelf: false, emitEvent: true });
    }

    private isValueCorrect() {
        return this.formField.value.toString().toLowerCase() in this.sentimentsEnum;
    }

    private setPreselectedValue() {
        if (isNaN(+this.formField.value)) {
            this.formField.value = this.sentimentsEnum[this.formField.value.toLowerCase()];
        } else {
            this.formField.value = +this.formField.value;
        }
    }
}
